import fetch from '../fetch'
import history from '../history'

class BaseApi {
  get jsonHeaders () {
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Cache-Control': 'no-store, no-cache'
    }

    return this.addAuthHeaders(headers)
  }

  get baseApiUrl () {
    // Check if running in browser (client-side)
    if (typeof window !== 'undefined' && window.__API__) {
      return window.__API__
    }

    // Server-side: use the REAL API (not fake)
    return process.env.APP_API_URL || 'http://localhost:8080/api'
  }

  handleResponse (type, response) {
    return {
      type: type,
      payload: response
    }
  }

  handleResponseAwait (type, response) {
    return async (dispatch) => {
      dispatch({
        type: type,
        payload: response
      })
      return response
    }
  }

  getJson (partialUrl, body) {
    const base = this.baseApiUrl.replace(/\/$/, '')
    const partial = partialUrl.replace(/^\//, '')
    let fullUrl = `${base}/${partial}`

    return fetch(fullUrl, {
      method: 'GET',
      headers: this.jsonHeaders
    })
      .then((response) => this.checkStatus(response, partialUrl))
      .then(response => response.json())
      .catch((err) => {
        if (err && (err.status === 400 || err.status === 401 || err.status === 403)) {
          throw err
        }

        this.handleError(err)
        throw err
      })
  }

  putJson (partialUrl, payload) {
    let fullUrl = `${this.baseApiUrl}${partialUrl}`

    return fetch(fullUrl, {
      method: 'PUT',
      headers: this.jsonHeaders,
      body: JSON.stringify(payload)
    })
      .then((response) => this.checkStatus(response, partialUrl))
      .catch((err) => {
        if (err && (err.status === 400 || err.status === 401 || err.status === 403)) {
          throw err
        }

        this.handleError(err)
        throw err
      })
  }

  postJson (partialUrl, payload) {
    let fullUrl = `${this.baseApiUrl}${partialUrl}`


    return fetch(fullUrl, {
      method: 'POST',
      headers: this.jsonHeaders,
      body: JSON.stringify(payload)
    })
      .then((response) => this.checkStatus(response, partialUrl))
      .catch((err) => {
        if (err && (err.status === 400 || err.status === 401 || err.status === 403)) {
          throw err
        }

        this.handleError(err)
        throw err
      })
  }

  deleteJson (partialUrl, payload) {
    let fullUrl = `${this.baseApiUrl}${partialUrl}`

    return fetch(fullUrl, {
      method: 'DELETE',
      headers: this.jsonHeaders,
      body: JSON.stringify(payload)
    })
      .then((response) => this.checkStatus(response, partialUrl))
      .catch((err) => {
        if (err && (err.status === 400 || err.status === 401 || err.status === 403)) {
          throw err
        }

        this.handleError(err)
        throw err
      })
  }

  checkStatus (response, partialUrl = '') {
    const isLoginRequest = partialUrl.includes('/administrators/login')

    if (response.status === 401 || response.status === 403) {
      if (!isLoginRequest) {
        if (typeof global.localStorage !== 'undefined') {
          global.localStorage.removeItem('token')
        }

        if (typeof window !== 'undefined') {
          window.location.replace('/find-an-ifa/administration/unauthorized')
        }
      }

      const error = new Error('Unauthorized')
      error.status = response.status
      error.response = response
      throw error
    }

    if (response.status === 404) {
      if (typeof window !== 'undefined') {
        history.push('/not-found')
      }

      const error = new Error('Not Found')
      error.status = response.status
      error.response = response
      throw error
    }

    if (response.status >= 200 && response.status < 300) {
      return response
    } else {
      var error = new Error(response.statusText || 'Request Failed')
      error.status = response.status
      error.response = response
      throw error
    }
  }

  handleError (err) {
     if (err && (err.status === 400 || err.status === 401 || err.status === 403)) {
      throw err
    }

    if (typeof window !== 'undefined') {
      const e = {
        name: err.response ? err.response.statusText : 'Error',
        message: err.message || 'Network request error',
        stack: err.response ? err.response.url : '',
        status: err.response ? err.response.status : 500
      }
      history.push('/error', { error: e })
    } else {
      console.error('API Error during SSR:', err.message || err)
      throw err
    }
  }

  addAuthHeaders (headers) {
    if (typeof global.localStorage !== 'undefined') {
      var token = global.localStorage.getItem('token')
      if (token !== 'undefined' && token !== 'null' && token) {
        token = JSON.parse(token)
        if (token) {
          headers['Authorization'] = `Bearer ${token}`
        }
      }
    }
    return headers
  }
}

export default BaseApi
